module.exports = __webpack_public_path__ + "media/images/webpage/coupons/howto-selected-534663eaa8bc4592950fbc3af8c965e6.webp";